import { render, staticRenderFns } from "./GroupBuyOrderPane.vue?vue&type=template&id=106e2e86&scoped=true"
import script from "./GroupBuyOrderPane.vue?vue&type=script&lang=js"
export * from "./GroupBuyOrderPane.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyOrderPane.vue?vue&type=style&index=0&id=106e2e86&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e2e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106e2e86')) {
      api.createRecord('106e2e86', component.options)
    } else {
      api.reload('106e2e86', component.options)
    }
    module.hot.accept("./GroupBuyOrderPane.vue?vue&type=template&id=106e2e86&scoped=true", function () {
      api.rerender('106e2e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/groupBuy/GroupBuyOrderPane.vue"
export default component.exports